const jobs = {
  update: {
    summary: {
      supplier: 'Flotte',
      notRouted: 'Nicht verteilt',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Flotte',
      },
    },
  },
  table: {
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
      route: 'Verteilen',
      cancel: 'Stornieren',
      routeAndAssign: 'Weiterleiten und Zuweisen',
      group: 'Gruppe',
      ungroup: 'Gruppierung aufheben',
      blockWaitAndReturn: 'Deaktivieren Sie Warten und Zurückgeben',
      unblockWaitAndReturn: 'Warten und Zurückgeben aktivieren',
      manualRoute: 'Manuelle Route',
      releaseRouting: 'Freigaberouting',
    },
    cells: {
      supplier: {
        none: 'Keine Flotte',
      },
      actions: {
        approve: 'Akzeptieren',
        remove: 'Ablehnen',
      },
    },
    filters: {
      supplier: 'Flotten',
    },
    headers: {
      supplier: 'Flotten',
    },
    statuses: {
      new: 'Nicht verteilt',
      routed: 'Verteilt',
      onHold: 'In der Warteschleife',
      canceled: 'Storniert',
      routing: 'Routenplanung',
      picked: 'Ausgewählt',
      dropped: 'Abgesetzt',
      noshow: 'Nichterscheinen',
    },
  },
};

export default jobs;
